import { render, staticRenderFns } from "./FolderCreateModal.vue?vue&type=template&id=be212a82&"
import script from "./FolderCreateModal.vue?vue&type=script&lang=ts&"
export * from "./FolderCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./FolderCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports